"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  de: {
    collapseTextOverlayOptions: 'Optionen für die Textdarstellung einklappen',
    disableTextOverlay: 'Textdarstellung deaktivieren',
    enableTextOverlay: 'Textdarstellung aktivieren',
    expandTextOverlayOptions: 'Optionen für die Textdarstellung ausklappen',
    textOpacity: 'Text-Transparenz',
    textSelect: 'Text auswählbar',
    textVisible: 'Text sichtbar',
    colorPicker: 'Farbauswahl',
    textColor: 'Farbe für Text',
    backgroundColor: 'Farbe für Zeilenhintergrund',
    resetTextColors: 'Farben zurücksetzen'
  },
  en: {
    collapseTextOverlayOptions: 'Collapse text overlay options',
    disableTextOverlay: 'Disable text overlay',
    enableTextOverlay: 'Enable text overlay',
    expandTextOverlayOptions: 'Expand text overlay options',
    textOpacity: 'Text opacity',
    textSelect: 'Text selectable',
    textVisible: 'Text visible',
    colorPicker: 'Color picker',
    textColor: 'Text color',
    backgroundColor: 'Line background color',
    resetTextColors: 'Reset colors'
  }
};
exports["default"] = _default;